import {
    createStyles,
    Toolbar,
    WithStyles,
    withStyles,
} from "@material-ui/core";
import * as React from "react";

import { NoResultsText } from ".";
import {
    EnhancedTable,
    TableColumn,
    TableOptionActions,
    TableOptions,
    Text,
} from "../../";

const styles = () =>
    createStyles({
        root: {},
    });

export interface SearchResultsProps {
    onRequestSort?: (
        event: React.MouseEvent<HTMLElement, MouseEvent>,
        property: string
    ) => void;
    actions?: TableOptionActions[];
    actionComponent?: React.ReactNode;
    toolbarClassName?: string;
    getColumns: () => TableColumn[];
    hideCheckbox?: boolean;
    data: any;
    sortDir?: SortDir;
    sortField?: string;
    totalCount: number;
    refined?: boolean;
    noResultsText?: string;
    selectedRows?: string[];
    onSelectedAction?: (action: string) => void;
    onSelectAll?: () => void;
    onDeselectAll?: () => void;
    onRowChecked?: (rowId: string) => void;
    onRowUnchecked?: (rowId: string) => void;
    isBusy?: boolean;
    rowBody?: (row: any) => React.ReactElement;
    entityName?: string;
    checkboxDisabled?: boolean;
}

type OwnProps = SearchResultsProps & WithStyles<typeof styles>;

export const SearchResultsList = withStyles(styles, {
    name: "SearchResultsList",
})((props: OwnProps) => {
    const {
        actionComponent,
        toolbarClassName,
        actions,
        data,
        getColumns,
        hideCheckbox = true,
        entityName,
        noResultsText = "Sorry, no " +
            (entityName ? entityName : "records") +
            " found.",
        isBusy,
        onRequestSort,
        sortDir,
        sortField,
        totalCount,
        selectedRows = [],
        onSelectedAction,
        onSelectAll,
        onDeselectAll,
        onRowChecked,
        onRowUnchecked,
        rowBody,
        checkboxDisabled,
    } = props;

    const options: TableOptions = {
        color: "primary",
        onRequestSort,
        onSelectedAction,
        actions,
        actionComponent,
        toolbarClassName,
        order: sortDir,
        orderBy: sortField,
        count: totalCount,
        hideCheckbox,
        title: "results",
        titleVariant: "h2",
        onSelectAll,
        onDeselectAll,
        onRowChecked,
        onRowUnchecked,
        rowBody,
        checkboxDisabled,
    };

    return totalCount > 0 ? (
        <EnhancedTable
            options={options}
            columns={getColumns()}
            data={data()}
            selectedRows={selectedRows}
            dataCy={"searchResultsList"}
        />
    ) : !isBusy ? (
        <>
            <Toolbar disableGutters={true}>
                <Text variant="h2">results</Text>
            </Toolbar>
            <NoResultsText data-cy="noResultsText">
                {noResultsText}
            </NoResultsText>
        </>
    ) : null;
});

SearchResultsList.displayName = "SearchResultsList";
